import { UnitSearchOptions } from "constant/dl_unit/dl_unit.constant";
import { axiosCitajteo } from "../../axios/citajteo_axios";
import { DlUnit } from "model/dl_unit/DlUnit";

export const unitGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: DlUnit | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(`dl-unit/${id}?searchBy=${searchBy}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = new DlUnit(response.data);
  }

  return result;
};

export type UnitSearchParams = Partial<
  Record<UnitSearchOptions, number | string>
>;

export type UnitAddParams = {
  slug: string;
  uType: string;
  num: number;
  fold: string;
  scans: string[];
  fVals: Record<string, string>;
  pdf: any;
};

export type UnitUpdateParams = Partial<UnitAddParams>;

const unitResponseFormat = (unit: any): any => {
  const result = { ...unit };

  return result;
};

export const unitSearch = async (
  searchParams?: UnitSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(`dl-unit/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => unitResponseFormat(item));
  }

  return result;
};

export const unitAdd = async (
  addParams: UnitAddParams
): Promise<string | null> => {
  let result: string | null = null;
  let response: any;

  try {
    response = await axiosCitajteo.post("dl-unit", addParams);
  } catch (error) {
    console.log("unitAdd - error", error);
  }

  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

export const unitUpdate = async (
  id: string,
  updatePayload: UnitUpdateParams
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`dl-unit/${id}`, updatePayload);
  } catch (error) {
    console.log("unitUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const unitDelete = async (id: string): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.delete(`dl-unit/${id}`);
  } catch (error) {
    console.log("unitDelete - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};
